(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-slider"] && !window.DesignMode) return;
  try {
    
(window.webpackJsonp=window.webpackJsonp||[]).push([[7],{308:function(e,t,n){"use strict";n.r(t);var o=n(35),r=n.n(o);n(180);document.addEventListener("DOMContentLoaded",(function(){var e=document.querySelector(".featured-collections__slider");if(e){var t="true"===e.dataset.arrows;new r.a(e,{cellAlign:"left",contain:!0,freeScroll:!0,groupCells:!0,imagesLoaded:!0,prevNextButtons:t,setGallerySize:!0,pageDots:!0,arrowShape:"M41.743 45.833L64.62 22.955l-4.242-4.243-27.122 27.121L60.38 72.955l4.242-4.243-22.878-22.879z"})}}))}},[[308,0,1]]]);

  } catch(e) { console.error(e); }
})();
})();
